(function ($) {
  "use strict";
  $(function () {
    $(".js-faq-category-item").on("click", function (e) {
      e.preventDefault();
      $(this)
        .parent()
        .find(".js-faq-category-item.active")
        .removeClass("active");
      $(this).addClass("active");
      $(".js-faq-category.active").removeClass("active");
      $(`.js-faq-category[id="${$(this).attr("href").substring(1)}"]`).addClass(
        "active"
      );
    });

    $(".js-faq-question").on("click", function (e) {
      $(this).parent().toggleClass("active");
      $(this).next(".js-faq-answer").slideToggle();
    });
  });
})(jQuery);
